import { mainStore } from "../stores/MainStore";

export const useChatCategoryStore = () => {
  return mainStore.chatCategoryStore;
};